var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$path('references', _vm.value))?_c('ResidentialTemplates',{staticClass:"residential-templates",attrs:{"value":_vm.value}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }